import { render, staticRenderFns } from "./OrderTotalsTable.vue?vue&type=template&id=30421f44&scoped=true"
import script from "./OrderTotalsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderTotalsTable.vue?vue&type=script&setup=true&lang=js"
import style0 from "./OrderTotalsTable.vue?vue&type=style&index=0&id=30421f44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30421f44",
  null
  
)

export default component.exports